import React, { useMemo } from "react";

import { WEB_LAYOUT } from "../../constant";
import InboxItem from "./InboxItem";
import InboxItemV4 from "./InboxItem_v4";

const InboxItemSelector = (props) => {
  const inboxItem = useMemo(() => {
    switch (WEB_LAYOUT) {
      case "v4":
        return <InboxItemV4 {...props} />;
      default:
        return <InboxItem {...props} />;
    }
  }, [props]);
  return inboxItem;
};

export default InboxItemSelector;
